import jApplicationManager from '@/views/application-manager/jApplicationManager';
import jAppManagerDetail from '@/views/application-manager/detail/jAppManagerDetail';
import jAppManagerDetailGroup from '@/views/application-manager/detail/jAppManagerDetailGroup';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/application-manager',
    name: 'jApplicationManager',
    component: jApplicationManager,
    meta: {
      title: 'Application Manager',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/application-manager/group/:groupId',
    name: 'jAppManagerDetailGroup',
    component: jAppManagerDetailGroup,
    meta: {
      title: 'Application Group Detail',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/application-manager/:tab/:applicationId',
    name: 'jAppManagerDetail',
    component: jAppManagerDetail,
    meta: {
      title: 'Application Detail',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/application-manager/:applicationId',
    name: 'jAppManagerDetail',
    component: jAppManagerDetail,
    meta: {
      title: 'Application Detail',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterApp.js